
export default function BurgerMenuAnimated() {
  return (
    <div id="nav-icon3">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}
